import React from "react";
// import avitar from "../avitar.png"   you can import or use require
import "../resume.css";


 function Resume()  {

  
return ( 
    <>
    <div className="resume">
        <div className="resStyle">
           <div className="column">
            <div className="title">
              Jay Tranberg <br></br>
            </div>
            
Fullstack Developer<br></br>
Victoria, BC, Canada<br></br>
Phone: +1-250-516-1137<br></br>
Email: jtranberg@hotmail.ca<br></br>
<a href="https://www.jaytranberg.com">Personal website</a> | <a href="https://www.linkedin.com/in/jaytranberg/">LinkedIn </a>| <a href="https://github.com/">GitHub</a> | <a href="https://jay-tranberg-dev-portfolio.netlify.app/">Portfolio</a><br></br>
<br></br>
Skills:<br></br>
Programming Languages: HTML5, CSS, JavaScript, Python, Java, Solidity (Intermediate+)<br></br>
Frameworks: React (Intermediate)<br></br>
Tools: GitHub, VS Code (Intermediate)<br></br>
Databases: PostgreSQL, MySQL, Excel, Django, Flask (Intermediate)<br></br>
Other: Docker, Kubernetes (Familiar)<br></br>
<br></br>
Work Experience:<br></br>
Jay Tranberg Contracting<br></br>
Lead Web/App Developer (2016 - Current)<br></br>
Led various projects from inception to CI/CD, including web apps, mobile apps, and data structures.<br></br>
Developed API web scraper application for specific user data requests.<br></br>
Built a decentralized NFT Minting Platform.<br></br>
Developed a Dapp for local businesses to accept crypto, resulting in a 25% increase in revenue.<br></br><br></br>
Gonzo Entertainment:<br></br>
Remote Full Stack UI Developer (2024 - Current)<br></br>
Maintained and improved UI layout on WordPress site using custom CSS.<br></br>
Enhanced security measures.<br></br>
Increased site visit time by 100% and decreased bounce rate by 47%.<br></br>
Investigated and resolved email sending issues from the server.<br></br><br></br>
Art Szabo:<br></br>
Full Stack Developer (2022 - 2024)<br></br>
Developed an app to extend business visibility and user access for Dee-Lake.<br></br>
Integrated APIs for online registration and booking reservations.<br></br>
Created a proof of concept app under a tight deadline, incorporating client-side UI and existing databases.<br></br><br></br>
Band Brand:<br></br>
Remote UI Developer (2022 - 2024)<br></br>
Provided problem-solving and CSS front-end elements creation for the website.<br></br>
Developed custom JS code and CSS buttons for UI enhancement.<br></br>
Andrew Spark<br></br>
Full Stack Developer (2022 - 2024)<br></br>
Solved layout issues and implemented custom CSS for the website.<br></br>
Addressed code issues with add-on plugins and created custom scripts for UI animations.<br></br>
<br></br>

Education:<br></br>
Associates degree  Computer Science (Expected Completion: 2025), University of People<br></br>
Fullstack Bootcamp<br></br>
JavaScript Bootcamp<br></br>
TypeScript Bootcamp<br></br>
CSS Elements Creation Workshop<br></br>
NFT Bootcamp/Ethereum<br></br>
Ethereum Blockchain Bootcamp<br></br>
DeFi Staking Dapp Course<br></br>
Smart Contract Course, Smart contract Gas saving course.<br></br>
Blockchain A/Z Bootcamp<br></br>

References:<br></br>
Available upon request.<br></br>
Updated: Aug 2024<br></br>
</div><br></br>
</div >
 {/* <img className="avitarR" src={require('../images/avitar.jpg')} alt="pic"/> <br></br> */}

</div>
</>
);
}
export default Resume;